import React from 'react';
import { useSpring, animated } from 'react-spring';

const BcrumbBannerOne = ({ title, paragraph, tituloabranco, mainThumb }) => {
  const [springProps, setSpring] = useSpring(() => ({
    scale: 1,
  }));

  const isLight = tituloabranco === 'yes';

  return (
    <div
      className="breadcrum-area breadcrumb-banner"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + mainThumb})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        position: 'relative',
      }}
    >
      {/* subtle overlay for text contrast */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: isLight
            ? 'rgba(0,0,0,0.45)'
            : 'rgba(255,255,255,0.25)',
          zIndex: 1,
        }}
      ></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="section-heading heading-left" style={{ marginLeft: '10%' }}>
          <animated.div
            style={{
              transform: springProps.scale.to((s) => `scale(${s})`),
              cursor: 'pointer',
            }}
            onMouseEnter={() => setSpring({ scale: 1.1 })}
            onMouseLeave={() => setSpring({ scale: 1 })}
          >
            <p
              className={
                isLight ? 'title h2 LightTitle' : 'title h2 DarkTitle'
              }
              style={{
                fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                fontWeight: 700,
                lineHeight: 1.1,
                color: isLight ? '#fff' : '#111',
                textShadow: isLight
                  ? '0 2px 8px rgba(0,0,0,0.5)'
                  : '0 2px 4px rgba(255,255,255,0.4)',
              }}
              dangerouslySetInnerHTML={{ __html: title }}
            ></p>

            <p
              className={isLight ? 'LightSubtitle' : 'DarkSubtitle'}
              style={{
                fontSize: 'clamp(1.1rem, 2vw, 1.6rem)',
                color: isLight ? '#f3f3f3' : '#222',
                textShadow: isLight
                  ? '0 1px 6px rgba(0,0,0,0.4)'
                  : '0 1px 4px rgba(255,255,255,0.3)',
                maxWidth: '800px',
              }}
              dangerouslySetInnerHTML={{ __html: paragraph }}
            ></p>
          </animated.div>
        </div>
      </div>

      <ul className="shape-group-8 list-unstyled" style={{ position: 'relative', zIndex: 0 }}>
        <li className="shape shape-3">
          <img
            src={process.env.PUBLIC_URL + '/images/others/line-4.webp'}
            alt="Line"
          />
        </li>
      </ul>
    </div>
  );
};

export default BcrumbBannerOne;
